import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { ActivityKind } from 'entities/TableCellActivity';

import { ChangeActivity } from './ChangeActivity';
import { CommentActivity } from './CommentActivity';
import { StatusChangeActivity } from './StatusChangeActivity';
import { ActivityRendererProps } from './types';

const ActivityRenderer: React.FC<ActivityRendererProps> = ({
  entity,
  onDelete,
  onEdit,
}: ActivityRendererProps) => {
  if (entity.type === ActivityKind.change) {
    return (
      <ChangeActivity onEdit={onEdit} onDelete={onDelete} entity={entity} />
    );
  }

  if (entity.type === ActivityKind.status_change) {
    return (
      <StatusChangeActivity
        onEdit={onEdit}
        onDelete={onDelete}
        entity={entity}
      />
    );
  }

  return (
    <CommentActivity onEdit={onEdit} onDelete={onDelete} entity={entity} />
  );
};

export default observer(ActivityRenderer);
